var map = {
	"./baseball-player.png": 495,
	"./baseball.png": 496,
	"./bump.png": 497,
	"./dive-down.png": 498,
	"./firefighter.png": 499,
	"./frog-jump.png": 500,
	"./helicopter.png": 501,
	"./jet.png": 502,
	"./karate-kick.png": 503,
	"./magic-c.png": 504,
	"./pole.png": 505,
	"./slide-away.png": 506,
	"./slide-down.png": 507,
	"./smile.png": 508,
	"./swim.png": 509,
	"./tow.png": 510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;